define('sentient/aba/views/SessionView',[
    'modernizr',
    'jquery',
    'underscore',
    'backbone',
    'loglevel',
    'domReady',
    '../app',
    '../models/SessionModel',
    '../Percentile',
    '../GaugeVertical',
    '../GaugeCircle',
    './TouchView'
], function(
    modernizr, $, _, Backbone, log, domReady,
    app, SessionModel, Percentile,
    gaugeVertical, gaugeCircle,
    TouchView) {
    log.trace('running SessionView.js');
    var $document = $(this.document || {});

    var SessionView = Backbone.View.extend({
        el: $('.sentient-aba-session'),
        model: SessionModel,
        defaults: function() {},
        selectUp: function(event) {
            return true;
        }, //do nothiong
        selectDown: function(event) {
            return true;
        }, //do nothing
        movestart: function(event) {
            if (this.model.get('allowScroll') === true) {
                event.preventDefault();
                return false;
            } else {
                //log.debug("movestart:",event);
                //Save all the movestart touch time stamps
                if (event && event.targetTouches && event.targetTouches[0] && app && app.sessionView) {
                    if (!app.sessionView.movestarts) {
                        app.sessionView.movestarts = {};
                    }
                    app.sessionView.movestarts[event.targetTouches[0].identifier] = {
                        'timestamp': event.timeStamp
                    };
                    //log.debug("event.targetTouches[0].identifier:",event.targetTouches[0].identifier);
                    //log.debug("app.sessionView.movestarts:",app.sessionView.movestarts);
                }
                return false;
            }
        },
        initialize: function() {

            this.$el.css('min-height', '200px');

            this.targetUpper = this.$el.find('.target.upper');
            this.targetUpperLabel = this.targetUpper.find('.label');
            this.targetLower = this.$el.find('.target.lower');
            this.targetLowerLabel = this.targetLower.find('.label');

            this.dialog = this.$el.find('.dialog');
            this.taskHandle = this.$el.find('.task-handle');

            this.outerFrame = this.$el.parent('.sentient-aba-session-frame');


            this.taskTimeout = function() {};
            this.taskTimeoutHandle = null;

            this.led = {};
            this.led.upper = this.$el.find('.led.upper');
            this.led.upper.correct = this.led.upper.find('.green');
            this.led.upper.incorrect = this.led.upper.find('.red');
            this.led.upper.selected = this.led.upper.find('.green');


            this.led.lower = this.$el.find('.led.lower');
            this.led.lower.correct = this.led.lower.find('.green');
            this.led.lower.incorrect = this.led.lower.find('.red');
            this.led.lower.selected = this.led.lower.find('.green');



            this.arrows = {};
            this.arrows.up = this.$el.find('.arrow.up');
            this.arrows.down = this.$el.find('.arrow.down');
            //Some constents for caculating the arrow animation.
            this.arrows.animation = {
                start: { /*dimentions (65x112)*/
                    widthFactor: 65 / 127,
                    heightFactor: 112 / 220,
                    time: 0
                },
                end: { /*dimentions (127x220)*/
                    widthFactor: 127 / 127,
                    heightFactor: 220 / 220,
                    time: 1000
                }
            };

            this.gaugeContainer = $('.gauge-vertical-container');



            this.minSaGauge = this.$el.find('.min-subconscious-associations.gauge');
            this.minSaGaugeIcon = this.$el.find('.min-subconscious-associations.gauge .symbol.bottom');
            this.minSaGaugeLabel = this.$el.find('.min-subconscious-associations.gauge-label');

            this.maxSaGauge = this.$el.find('.max-subconscious-associations.gauge');
            this.maxSaGaugeIcon = this.$el.find('.max-subconscious-associations.gauge .symbol.bottom');
            this.maxSaGaugeLabel = this.$el.find('.max-subconscious-associations.gauge-label');

            this.speedGauge = this.$el.find('.speed.gauge');
            this.speedGaugeLabel = this.$el.find('.speed.gauge-label');

            this.accuracyGauge = this.$el.find('.accuracy.gauge');
            this.accuracyGaugeLabel = this.$el.find('.accuracy.gauge-label');
            this.completedGauge = this.$el.find('.progress.gauge');

            this.dialogFrame = this.$el.find('.dialog-frame');
            this.dialog = this.dialogFrame.find('.dialog');

            this.countdown = this.$el.find('.countdown-dialog');

            this.taskContainer = this.$el.find('.task-container');
            this.primeContainer = this.$el.find('.prime-container');

            this.pauseDialog = this.$el.find('.pause-dialog');
            this.pauseButtom = this.$el.find('.pause-button');
            this.pauseButtom.on('click', null, {
                'model': this.model,
                'button': this.pauseButtom
            }, function($event) {
                //log.debug("click",$event.data);
                var model = $event.data.model;
                var button = $event.data.button;
                if (model.get('pausable') && button.hasClass('pause')) {
                    model.set('paused', true);
                } else if (model.get('pausable') && button.hasClass('play')) {
                    model.set('paused', false);
                }
            });

            this.sessionEndDialog = this.$el.find('.end-session-dialog');
            gaugeVertical(this.$el.find('.gauge.vertical'));
            gaugeCircle(this.completedGauge);

            this.exerciseId = 0;
            this.taskId = 0;


            $(window).on('resize', _.debounce(_.bind(this.resize, this), 100));
            this.updateViewDimensions();
            this.verticallyCenterElements();
            this.$el.removeClass('not-ready');
            //log.debug('this.$el', this.$el);

            //listen to changes in the model
            this.listenTo(this.model, 'change:dialog', this.displayDialog);
            this.listenTo(this.model, 'change:bucket-top', this.displayBucketTop);
            this.listenTo(this.model, 'change:bucket-bottom', this.displayBucketBottom);
            this.listenTo(this.model, 'change:countdown', this.displayCoundown);
            this.listenTo(this.model, 'change:saMin', this.setSaMinGauge);
            this.listenTo(this.model, 'change:saMax', this.setSaMaxGauge);
            this.listenTo(this.model, 'change:speed', this.setSpeedGauge);
            this.listenTo(this.model, 'change:averageSpeed', this.setAverageSpeedGauge);
            this.listenTo(this.model, 'change:accuracy', this.setAccuracyGauge);
            this.listenTo(this.model, 'change:averageAccuracy', this.setAverageAccuracyGauge);
            this.listenTo(this.model, 'change:completedTaskCount', this.setCompletedGauge);
            this.listenTo(this.model, 'change:taskCount', this.resetCompletedGauge);
            this.listenTo(this.model, 'change:task', this.presentTaskToUser);
            this.listenTo(this.model, 'change:prime', this.presentPrimeToUser);
            this.listenTo(this.model, 'change:pausable', this.pauseHandler);
            this.listenTo(this.model, 'change:paused', this.displayPauseDialog);
            this.listenTo(this.model, 'change:sessionEndLayout', this.configureSessionEndLayout);
            this.listenTo(this.model, 'change:maxSaLabel', this.setMaxSaLabel);
            this.listenTo(this.model, 'change:maxSaIcon', this.setMaxSaIcon);
            this.listenTo(this.model, 'change:minSaLabel', this.setMinSaLabel);
            this.listenTo(this.model, 'change:minSaIcon', this.setMinSaIcon);
            this.listenTo(this.model, 'change:speedLabel', this.setSpeedLabel);
            this.listenTo(this.model, 'change:accuracyLabel', this.setAccuracyLabel);
            this.listenTo(this.model, 'change:sessionEndMessage', this.setSessionEndMessage);
            this.listenTo(this.model, 'change:iconsVisible', this.setIconsVisible);
            this.listenTo(app, 'resizeComplete', this.verticallyCenterElements);
            this.listenTo(app, 'resizeComplete', this.updateScreenResolution);

            var $tic = $('.touch-input-capture');
            if (modernizr.touch) {
                //log.debug("modernizr.touch");
                var touchView = this.touchView = new TouchView({
                    el: $tic
                });
                this.listenTo(this.model, 'change:allowScroll', function(sessionModel, allowScroll, options) {
                    touchView.passThrough = allowScroll;
                });
                this.touchView
                    .on('swipeup', $.proxy(function($event) {
                        //log.debug('swipeup',$event);
                        this.selectUp($event);
                        return true;
                    }, this))
                    .on('swipedown', $.proxy(function($event) {
                        //log.debug('swipedowns',$event);
                        this.selectDown($event);
                        return true;
                    }, this));
            } else {
                $tic.remove();
            }

            $document.on('keydown', null, null, $.proxy(
                function($event) {
                    var keyCode = $event.keyCode || $event.which,
                        arrow = {
                            left: 37,
                            up: 38,
                            right: 39,
                            down: 40
                        };
                    switch (keyCode) {
                        case arrow.up:
                            this.selectUp($event);
                            break;
                        case arrow.down:
                            this.selectDown($event);
                            break;
                    }
                    return true;
                }, this));
        },
        events: {
            'click .end-session-dialog .retry-session': 'triggerRetrySession'
        },
        noopEventHandler: function($event) {
            $event.preventDefault();
            return false;
        },
        render: function() {
            this.reRenderDialog();
        },
        remove: function() { //Overide the default remove so we can unbind
            $(window).off('resize', this.resize);
            //call the superclass remove method
            Backbone.View.prototype.remove.apply(this, arguments);
        },
        resize: function(event) {
            this.updateViewDimensions();
            this.verticallyCenterElements();
            this.render();
        },
        updateViewDimensions: function(argument) {
            this.viewWidth = this.$el.width();
            this.viewHeight = this.$el.height();
            this.viewOuterHeight = this.$el.outerHeight();
            this.targetDiameter = Math.min(this.viewWidth * (276 / 742), 300);
            this.targetVisableHeight = (this.targetDiameter * (95 / 276));
            /*
            log.debug({
                "event": "updateViewDimensions",
                viewWidth: this.viewWidth,
                viewHeight: this.viewHeight,
                viewOuterHeight: this.viewOuterHeight,
                targetDiameter: this.targetDiameter,
                targetVisableHeight: this.targetVisableHeight
            });
            */

            if (this.viewWidth > this.viewHeight) {
                this.$el.removeClass('tall-layout').addClass('wide-layout');
                this.layout = 'wide';
            } else {
                this.$el.removeClass('wide-layout').addClass('tall-layout');
                this.layout = 'tail';
            }
            if (this.viewHeight < 240 && this.model.get('pausable')) {
                this.$el.find('.screen-size-dialog').removeClass('hidden');
                this.model.set('paused', true);
            } else {
                this.$el.find('.screen-size-dialog').addClass('hidden');
            }
        },
        verticallyCenterElements: function() {
            this.viewWidth = this.$el.width();
            this.viewHeight = this.$el.height();
            this.viewOuterHeight = this.$el.outerHeight();
            //Center the taskHandle
            if (this.taskHandle) {
                this.taskHandle.css({
                    'top': (this.viewHeight / 2) - (this.taskHandle.outerHeight() / 2)
                });
            }
            /*
            log.debug({
                "event": "verticallyCenterElements",
                viewWidth: this.viewWidth,
                viewHeight: this.viewHeight,
                viewOuterHeight: this.viewOuterHeight,
                taskHandle: this.taskHandle,
                taskHandle_outerHeight: this.taskHandle.outerHeight()
            });
            */

            //log.debug("this.$el.height()",this.$el.height());
            //log.debug("this.viewHeight",this.viewHeight);
            this.countdown.css({
                'top': (this.viewHeight / 2) - (this.countdown.outerHeight() / 2)
            });

            if (this.viewHeight < 300) {
                this.dialog.css({
                    'top': '10px',
                    'bottom': '10px'
                });
            } else {
                this.dialog.css({
                    'top': '',
                    'bottom': ''
                });
            }

            if (this.layout == 'wide') {
                this.sessionEndDialog.css({
                    'top': (this.viewHeight / 2) - (this.sessionEndDialog.outerHeight() / 2)
                });
            } else {
                this.sessionEndDialog.css({
                    'top': ''
                });
            }
        },
        triggerArrowAnimation: function() {
            var $initArrowUpHeight = this.arrows.up.outerHeight();
            var $initArrowUpWidth = this.arrows.up.outerWidth();
            var $initArrowDownHeight = this.arrows.down.outerHeight();
            var $initArrowDownWidth = this.arrows.down.outerWidth();

            var $animationTime = 1000;
            this.arrows.up.stop(true, true).css({
                'position': 'absolute',
                'visibility': 'visible',
                'top': this.viewHeight / 2 - ($initArrowUpHeight * this.arrows.animation.start.heightFactor),
                'left': this.viewWidth / 2 - ($initArrowUpWidth * this.arrows.animation.start.widthFactor) / 2,
                'width': $initArrowUpWidth * this.arrows.animation.start.widthFactor,
                'height': $initArrowUpHeight * this.arrows.animation.start.heightFactor,
                opacity: 1
            })
                .animate({
                        'top': 0 - $initArrowUpHeight * this.arrows.animation.end.heightFactor,
                        'left': this.viewWidth / 2 - ($initArrowUpWidth * this.arrows.animation.end.widthFactor) / 2,
                        'width': $initArrowUpWidth * this.arrows.animation.end.widthFactor,
                        'height': $initArrowUpHeight * this.arrows.animation.end.heightFactor,
                        opacity: 0.5
                    },
                    $animationTime,
                    'swing',
                    $.proxy(function() {
                        this.css({
                            'visibility': '',
                            'top': '',
                            'left': '',
                            'width': '',
                            'height': ''
                        });
                    }, this.arrows.up));

            this.arrows.down.stop(true, true).show().css({
                'position': 'absolute',
                'visibility': 'visible',
                'top': this.viewHeight / 2,
                'left': this.viewWidth / 2 - ($initArrowDownWidth * this.arrows.animation.start.widthFactor) / 2,
                'width': $initArrowDownWidth * this.arrows.animation.start.widthFactor,
                'height': $initArrowDownHeight * this.arrows.animation.start.heightFactor,
                opacity: 1
            })
                .animate({
                        'top': this.viewHeight,
                        'left': this.viewWidth / 2 - ($initArrowDownWidth * this.arrows.animation.end.widthFactor) / 2,
                        'width': $initArrowDownWidth * this.arrows.animation.end.widthFactor,
                        'height': $initArrowDownHeight * this.arrows.animation.end.heightFactor,
                        opacity: 0.5
                    }, $animationTime,
                    'swing',
                    $.proxy(function() {
                        this.css({
                            'visibility': '',
                            'top': '',
                            'left': '',
                            'width': '',
                            'height': ''
                        });
                    }, this.arrows.down));
        },
        saveResult: function(taskHandle, result) {
            //log.debug("saveResult",taskHandle);
            var touchInfo = {};

            var now = (new Date()).getTime();
            /*
        var taskMeta = taskHandle.data('taskMeta');
        //Something happend and the taskHandle.data proporty has not been set yet,. Delay a momant to wait for it.
        console.log("result",result,"taskMeta",JSON.stringify(taskMeta));
        if(taskMeta === null){
          console.log(taskMeta === null);
          _.delay(_.bind(this.saveResult,this), 1000, taskHandle,result);
          return;
        }*/
            var displayStart = taskHandle.taskMeta['displayStart'];
            var taskTime = 0;
            if (taskHandle.event && taskHandle.event.touchStartTimeStamp) {
                taskTime = taskHandle.event.touchStartTimeStamp - displayStart;
                taskHandle.event.touchStart = taskHandle.event.touchStartTimeStamp - displayStart;
                _(taskHandle.event.touchMove).each(function(touch, touchIndex, touchList) {
                    //log.debug("taskHandle.event touch",touch);
                    touch.time = touch.timeStamp - displayStart;
                });
            } else if (
                taskHandle.event &&
                taskHandle.event.timeStamp &&
                taskHandle.event.timeStamp > (now - 10000) && //Sanity check! make sure the event is less then  10 old!
                taskHandle.event.timeStamp < (now + 10000) //Sanity check! //FireFox as of v.22 will fail here due to bug 238041 (https://bugzilla.mozilla.org/show_bug.cgi?id=238041)
            ) {
                taskTime = taskHandle.event.timeStamp - displayStart;
            } else {
                taskTime = now - displayStart;
            }

            //log.debug("taskHandle.event",taskHandle.event);
            var eventType = 'none';
            var eventData = {};
            if (taskHandle && taskHandle.event && taskHandle.event.touchStartY && taskHandle.event.touchMove) {
                eventType = 'swipe';
                var event = taskHandle.event;
                var swipe = _.map(taskHandle.event.touchMove, function(move) {
                    //log.debug("move",move);
                    return [move.X - event.touchStartX, move.Y - event.touchStartY, move.time - event.touchStart];
                });
                swipe.unshift([0, 0, 0]);
                eventData = swipe;
                //log.debug("swipe",swipe);
            }
            if (taskHandle && taskHandle.event && taskHandle.event.type && taskHandle.event.type == 'keydown') {
                eventType = 'keydown';
            }



            //Calculate velocity
            /*var velocity = 0;
        if(taskHandle && taskHandle.event && taskHandle.event.touchStartY && taskHandle.event.touchMove ){
          var event = taskHandle.event;
          var lastMove = event.touchMove.slice(-1)[0];
          var distance = Math.abs(lastMove.Y - event.touchStartY);
          var time = (lastMove.timeStamp - event.touchStartTimeStamp);
          //log.debug("velocity",distance/time,"px/ms");
          velocity = distance/time;
        }*/

            var task = this.model.get('task');

            if (_.isNull(task)) {
                log.error("this.model.get('task') == ", JSON.stringify(task, null, 4));
                throw ("this.model.get('task') == null");
            }

            log.debug("saveResult: task", task);
            //If we are in a practice task, save it, but doent update any guages
            if (app.sessionModel.get('practice')) {
                app.sessionResultModel.addResult(
                    task.stepUID,
                    task.exerciseId,
                    task.primeName,
                    task.primeTime,
                    task.name,
                    taskTime,
                    result,
                    null,
                    null,
                    task.repeateId,
                    eventType,
                    eventData,
                    task.target_type,
                    taskHandle.selectedBucket,
                    taskHandle.selectedBucketOrientation,
                    taskHandle.rejectedBucket,
                    taskHandle.rejectedBucketOrientation
                );
                return;
            }

            this.model.set('completedTaskCount', (this.model.get('completedTaskCount') + 1));
            //log.debug('saveResult taskMeta:', taskMeta);

            var taskTimeMean = app.sessionResultModel.getTaskTimeMean(taskHandle.taskMeta.exerciseId);
            var speedSD = 0;
            speedSD = parseFloat(task.speedSD);


            var speedSM = 0;
            speedSM = parseFloat(task.speedSM);


            //log.debug('feedback: taskTimeMean', taskTimeMean);
            //log.debug('feedback: speedSM', speedSM);
            //log.debug('feedback: speedSD', speedSD);
            var feedbackZ_score = (speedSM - taskTimeMean) / (speedSD);
            //log.debug('feedback z-score', feedbackZ_score);
            var speedPercentile = Percentile(feedbackZ_score);
            //log.debug('feedback percentile', speedPercentile);
            this.model.set('speed', speedPercentile);

            var taskAccuracyMean = app.sessionResultModel.getTaskAccuracyMean(taskHandle.taskMeta.exerciseId);
            var countOfCorrectTasks = app.sessionResultModel.getCountOfCorrectTasks(taskHandle.taskMeta.exerciseId);
            if (result == 'correct') {
                countOfCorrectTasks = countOfCorrectTasks + 1;
            }


            var accuracySD = parseFloat(task.accuracySD);
            var accuracySM = parseFloat(task.accuracySM);
            //log.debug('accuracy: countOfCorrectTasks', countOfCorrectTasks);
            //log.debug('accuracy: accuracySD', accuracySM);
            //log.debug('accuracy: accuracySM', accuracySD);
            var accuracyPercentile = 0;
            var accuracyZ_score = 0;
            if (task.accuracySD != '0') {
                accuracyZ_score = (countOfCorrectTasks - accuracySM) / (accuracySD);
                //log.debug('accuracy z-score', accuracyZ_score);
                accuracyPercentile = Percentile(accuracyZ_score);
                //log.debug('accuracy percentile', accuracyPercentile);
                this.model.set('accuracy', accuracyPercentile);
            }

            app.sessionResultModel.addResult(
                task.stepUID,
                task.exerciseId,
                task.primeName,
                task.primeTime,
                task.name,
                taskTime,
                result, (accuracyPercentile) * 100, (speedPercentile) * 100,
                task.repeateId,
                eventType,
                eventData,
                task.target_type,
                taskHandle.selectedBucket,
                taskHandle.selectedBucketOrientation,
                taskHandle.rejectedBucket,
                taskHandle.rejectedBucketOrientation
            );

            /*
        //Debug code for the gauges
        if($('#gauge-debug-speed').length === 0){
          $('.sentient-aba-session').append($('<div id=gauge-debug-speed style="padding:5px;position:absolute;top:0;left:0;background:black;"></div>'));
        }
        var debug_output = "";
        debug_output = debug_output + "Sample Mean: " + speedSM + "ms<br>";
        debug_output = debug_output + "Standard Deviation: " + speedSD + "ms<br>";
        debug_output = debug_output + "Exercise Mean: " + Math.round(taskTimeMean) + "ms<br>";
        debug_output = debug_output + "Z-score: " + feedbackZ_score.toFixed(2) + "<br>";
        debug_output = debug_output + "Z-score table lookup: " + speedPercentile.toFixed(4) + "<br>";
        debug_output = debug_output + "Percentile: " + Math.round(((speedPercentile)) * 100) + "<br>";
        $('#gauge-debug-speed').html(debug_output);

        if($('#gauge-debug-accuracy').length === 0){
          $('.sentient-aba-session').append($('<div id=gauge-debug-accuracy style="padding:5px;position:absolute;top:0;right:0;background:black;"></div>'));
        }
        debug_output = "";
        debug_output = debug_output + "Sample Mean: " + accuracySM.toFixed(3) + "<br>";
        debug_output = debug_output + "Standard Deviation: " + accuracySD.toFixed(3) + "<br>";
        debug_output = debug_output + "Correct Answers: " + countOfCorrectTasks + "<br>";
        debug_output = debug_output + "Z-score: " + accuracyZ_score.toFixed(2) + "<br>";
        debug_output = debug_output + "Z-score table lookup: " + accuracyPercentile.toFixed(4) + "<br>";
        debug_output = debug_output + "Percentile: " + Math.round(((accuracyPercentile)) * 100) + "<br>";

        $('#gauge-debug-accuracy').html(debug_output);
        */
        },
        upCorrect: function(taskHandle) {
            if (typeof taskHandle.selectedBucket === 'undefined') {
                taskHandle.selectedBucket = this.targetUpperLabel.text();
                taskHandle.selectedBucketOrientation = 'up';
                taskHandle.rejectedBucket = this.targetLowerLabel.text();
                taskHandle.rejectedBucketOrientation = 'down';
            }
            if (taskHandle.data('taskIncorrect') === true) {
                taskHandle.data('taskIncorrect', null);
                this.saveResult(taskHandle, 'incorrect');
            } else {
                this.saveResult(taskHandle, 'correct');
            }
            //log.debug("upCorrect",taskHandle.event);
            taskHandle.stop(true, true).animate({
                    'top': 0 - this.taskHandle.outerHeight()
                }, 'fast', 'linear',
                $.proxy(function() {
                    this.taskHandle.addClass('hidden').css({
                        'top': ''
                    });
                    this.app.trigger('stepForward');
                }, {
                    'app': app,
                    'taskHandle': taskHandle
                })
            );

            var led = this.led.upper.correct;
            led.stop(true, true).animate({
                    'opacity': 1
                }, 0,
                $.proxy(function() {
                    this.animate({
                        'opacity': 0
                    });
                }, led)
            );

            this.endTaskCleanup(taskHandle.event);
        },
        upIncorrect: function(taskHandle) {
            if (typeof taskHandle.selectedBucket === 'undefined') {
                taskHandle.selectedBucket = this.targetUpperLabel.text();
                taskHandle.selectedBucketOrientation = 'up';
                taskHandle.rejectedBucket = this.targetLowerLabel.text();
                taskHandle.rejectedBucketOrientation = 'down';
            }
            taskHandle.data('taskIncorrect', true);
            //log.debug('upIncorrect', this);
            //this.saveResult(taskHandle,"incorrect");
            taskHandle.addClass('animated shake');
            setTimeout($.proxy(function() {
                this.taskHandle.removeClass('animated shake');
                //this.app.trigger('stepForward');
            }, {
                'taskHandle': taskHandle,
                'app': app
            }), 500);
            var led = this.led.upper.incorrect;
            //log.debug('this.led.upper.incorrect', this.led.upper.incorrect);
            led.stop(true, true).animate({
                    'opacity': 1
                }, 0,
                $.proxy(function() {
                    this.animate({
                        'opacity': 0
                    });
                }, led)
            );
            //this.endTaskCleanup();
        },
        upSelected: function(taskHandle) {
            //log.debug("upSelected", taskHandle);

            if (typeof taskHandle.selectedBucket === 'undefined') {
                taskHandle.selectedBucket = this.targetUpperLabel.text();
                taskHandle.selectedBucketOrientation = 'up';
                taskHandle.rejectedBucket = this.targetLowerLabel.text();
                taskHandle.rejectedBucketOrientation = 'down';
            }
            this.saveResult(taskHandle, 'selected');

            taskHandle.stop(true, true).animate({
                    'top': 0 - taskHandle.outerHeight()
                }, 'fast', 'linear',
                $.proxy(function() {
                    this.taskHandle.addClass('hidden').css({
                        'top': ''
                    });
                    this.app.trigger('stepForward');
                }, {
                    'app': app,
                    'taskHandle': taskHandle
                })
            );

            var led = this.led.upper.selected;
            led.stop(true, true).animate({
                    'opacity': 1
                }, 0,
                $.proxy(function() {
                    this.animate({
                        'opacity': 0
                    });
                }, led)
            );
            this.endTaskCleanup(taskHandle.event);
        },
        downSelected: function(taskHandle) {

            if (typeof taskHandle.selectedBucket === 'undefined') {
                taskHandle.selectedBucket = this.targetLowerLabel.text();
                taskHandle.selectedBucketOrientation = 'down';
                taskHandle.rejectedBucket = this.targetUpperLabel.text();
                taskHandle.rejectedBucketOrientation = 'up';
            }
            this.saveResult(taskHandle, 'selected');

            taskHandle.stop(true, true).animate({
                    'top': this.viewOuterHeight
                }, 'fast', 'linear',
                $.proxy(function() {
                    this.taskHandle.addClass('hidden').css({
                        'top': ''
                    });
                    this.app.trigger('stepForward');
                }, {
                    'app': app,
                    'taskHandle': taskHandle
                })
            );


            var led = this.led.lower.selected;
            led.stop(true, true).animate({
                    'opacity': 1
                }, 0,
                $.proxy(function() {
                    this.animate({
                        'opacity': 0
                    });
                }, led)
            );
            this.endTaskCleanup(taskHandle.event);
        },
        downCorrect: function(taskHandle) {
            //log.debug('downCorrect', this);
            if (typeof taskHandle.selectedBucket === 'undefined') {
                taskHandle.selectedBucket = this.targetLowerLabel.text();
                taskHandle.selectedBucketOrientation = 'down';
                taskHandle.rejectedBucket = this.targetUpperLabel.text();
                taskHandle.rejectedBucketOrientation = 'up';
            }
            if (taskHandle.data('taskIncorrect') === true) {
                taskHandle.data('taskIncorrect', null);
                this.saveResult(taskHandle, 'incorrect');
            } else {
                this.saveResult(taskHandle, 'correct');
            }
            //log.debug("downCorrect",taskHandle.event);
            taskHandle.stop(true, true).animate({
                    'top': this.viewOuterHeight
                }, 'fast', 'linear',
                $.proxy(function() {
                    this.taskHandle.addClass('hidden').css({
                        'top': ''
                    });
                    this.app.trigger('stepForward');
                }, {
                    'app': app,
                    'taskHandle': taskHandle
                })
            );
            var led = this.led.lower.correct;
            led.stop(true, true).animate({
                    'opacity': 1
                }, 0,
                $.proxy(function() {
                    this.animate({
                        'opacity': 0
                    });
                }, led)
            );
            this.endTaskCleanup(taskHandle.event);
        },
        downIncorrect: function(taskHandle) {
            if (typeof taskHandle.selectedBucket === 'undefined') {
                taskHandle.selectedBucket = this.targetLowerLabel.text();
                taskHandle.selectedBucketOrientation = 'down';
                taskHandle.rejectedBucket = this.targetUpperLabel.text();
                taskHandle.rejectedBucketOrientation = 'up';
            }
            taskHandle.data('taskIncorrect', true);
            //log.debug('downIncorrect', this);
            //this.saveResult(taskHandle,"incorrect");
            taskHandle.addClass('animated shake');
            setTimeout($.proxy(function() {
                this.taskHandle.removeClass('animated shake');
                //this.app.trigger('stepForward');
            }, {
                'taskHandle': taskHandle,
                'app': app
            }), 500);
            var led = this.led.lower.incorrect;
            led.stop(true, true).animate({
                    'opacity': 1
                }, 0,
                $.proxy(function() {
                    this.animate({
                        'opacity': 0
                    });
                }, led)
            );
            //this.endTaskCleanup();
        },
        displayDialog: function(model, value, options) {
            var dialogValue = value;
            //log.debug('displayDialog', dialogValue);
            if (dialogValue && dialogValue.message && dialogValue.message.length > 0) {
                this.dialog.find('.message').html(dialogValue.message);

                this.dialog.find('.bottom-bar .dialog-confirm-btn').first().unbind('click')
                    .one('click', null, null, $.proxy(function(argument) {
                        //log.debug('click .dialog-confirm-btn');
                        this.app.trigger('stepForward');

                    }, {
                        'app': app,
                        'sessionView': this
                    }));
                this.model.set('allowScroll', true);
                this.dialogFrame.addClass('become-visible-on-render');
                this.dialog.addClass('force-window-height');
                this.dialog.removeClass('hidden');
                setTimeout(function() {
                    app.windowView.trigger('resize-check');
                }, 0);

            } else {
                this.model.set('allowScroll', false);
                this.dialog.find('.message').text();
                this.dialogFrame.addClass('hidden');
                this.dialog.removeClass('force-window-height');
                app.windowView.trigger('resize-check');
                this.verticallyCenterElements();
            }
            this.render();
        },
        reRenderDialog: function() {
            if (!this.dialogFrame.hasClass('hidden') || this.dialogFrame.hasClass('become-visible-on-render')) {
                this.dialogFrame.removeClass('become-visible-on-render');
                this.dialogFrame.removeClass('hidden');
            } else {
                this.dialog.addClass('hidden');
            }
        },
        setSaMaxGauge: function(model, value, options) {
            //        log.debug('SessionView.setSaMaxGauge(', value, ')');
            if (value >= 0) {
                this.maxSaGauge.trigger('change', (value * 2) - 1);
                this.maxSaGauge.removeClass('hidden');
            } else {
                this.maxSaGauge.addClass('hidden');
            }
        },
        setSaMinGauge: function(model, value, options) {
            //        log.debug('SessionView.setSaMinGauge(', value, ')');
            if (value >= 0) {
                this.minSaGauge.trigger('change', (value * 2) - 1);
                this.minSaGauge.removeClass('hidden');
            } else {
                this.minSaGauge.addClass('hidden');
            }
        },
        setSpeedGauge: function(model, value, options) {
            //log.debug('SessionView.setSpeedGauge(', value, ')');
            if (value >= 0) {
                this.speedGauge.trigger('change', (value * 2) - 1);
                this.speedGauge.removeClass('hidden');
            } else {
                this.speedGauge.addClass('hidden');
            }
        },
        setAverageSpeedGauge: function(model, value, options) {
            //log.debug('SessionView.setSpeedGauge(', value, ')');
            if (value >= 0) {
                this.speedGauge.trigger('change', ((value / 100) * 2) - 1);
                this.speedGauge.removeClass('hidden');
            } else {
                this.speedGauge.addClass('hidden');
            }
        },
        setAccuracyGauge: function(model, value, options) {
            //log.debug('SessionView.setAccuracyGauge(', value, ')');
            if (value >= 0) {
                this.accuracyGauge.trigger('change', (value * 2) - 1);
                this.accuracyGauge.removeClass('hidden');
            } else {
                this.accuracyGauge.addClass('hidden');
            }
        },
        setAverageAccuracyGauge: function(model, value, options) {
            //log.debug('SessionView.setAccuracyGauge(', value, ')');
            if (value >= 0) {
                this.accuracyGauge.trigger('change', ((value / 100) * 2) - 1);
                this.accuracyGauge.removeClass('hidden');
            } else {
                this.accuracyGauge.addClass('hidden');
            }
        },
        resetCompletedGauge: function(model, value, options) {
            //log.debug('SessionView.resetCompletedGauge(', value, ')');
            if (value >= 0) {
                this.completedGauge.trigger('reset', value);
                this.completedGauge.removeClass('hidden');
            } else {
                this.completedGauge.addClass('hidden');
            }
        },
        setCompletedGauge: function(model, value, options) {
            //log.debug('SessionView.setCompletedGauge(', value, ')');
            if (value >= 0) {
                this.completedGauge.trigger('change', value);
                this.completedGauge.removeClass('hidden');
            } else {
                this.completedGauge.addClass('hidden');
            }
        },
        displayBucketTop: function(model, value, options) {
            //log.debug('SessionView.displayBucketTop(', value, ')');
            if (value) {
                this.targetUpperLabel.html(value);
                this.targetUpper.removeClass('hidden');
                this.led.upper.removeClass('hidden');
            } else {
                this.targetUpper.addClass('hidden');
                this.targetUpperLabel.html();
                this.led.upper.addClass('hidden');
            }
        },
        displayBucketBottom: function(model, value, options) {
            //log.debug('SessionView.displayBucketBottom(', value, ')');
            if (value) {
                this.targetLowerLabel.html(value);
                this.targetLower.removeClass('hidden');
                this.led.lower.removeClass('hidden');
            } else {
                this.targetLower.addClass('hidden');
                this.targetLowerLabel.empty();
                this.led.lower.addClass('hidden');
            }
        },
        displayCoundown: function(model, value, options) {
            //log.debug('SessionView.displayCoundown(', value, ')');
            if (value) {
                var countdown = value.countdownStart || 3;
                var countdownTime = value.countdownTime || 3000;
                this.countdown.find('.message').text(value.message);
                this.countdown.find('.countdown').text('');

                this.countdown.data('countdown', countdown);
                var interval = (countdownTime) / (countdown);

                var countdownCallback = $.proxy(function() {
                    var $countDownElm = $(this.countDownElm);
                    var app = this.app;
                    var messageElm = $countDownElm.find('.message');
                    var countdownTextElm = $countDownElm.find('.countdown');
                    var countdown = $countDownElm.data('countdown');
                    $countDownElm.removeClass('hidden');
                    if (countdown > 0) {
                        countdownTextElm.text(countdown.toString());
                        $countDownElm.data('countdown', countdown - 1);
                        clearTimeout($countDownElm.data('countdownTimeoutHandle'));
                        var countdownTimeoutHandle = setTimeout(countdownCallback, interval);
                        $countDownElm.data('countdownTimeoutHandle', countdownTimeoutHandle);
                    } else {
                        $countDownElm.data('countdownTimeoutHandle', null);
                        app.sessionModel.set('countdown', null);
                        setTimeout(function() {
                            app.trigger('stepForward');
                        }, 500);
                    }
                }, {
                    'countDownElm': this.countdown,
                    'app': app,
                    'countdownCallback': countdownCallback,
                    'interval': interval
                });
                clearTimeout(this.countdown.data('countdownTimeoutHandle'));
                var countdownTimeoutHandle = setTimeout(countdownCallback, 1000);
                this.countdown.data('countdownTimeoutHandle', countdownTimeoutHandle);
                app.windowView.trigger('resize-check');
                this.verticallyCenterElements();
                this.render();
            } else {
                var timeoutID = this.countdown.data('countdownTimeoutHandle');
                //log.debug('stoping countdown! Stoping timer ID:' + timeoutID);
                if (timeoutID >= 0) {
                    clearTimeout(timeoutID);
                    this.countdown.data('countdownTimeoutHandle', null);
                }
                this.verticallyCenterElements();
                this.countdown.addClass('hidden');
            }
        },
        presentTaskToUser: function(model, value, options) {
            var sessionView = this;
            //log.debug('SessionView. (', value.exerciseId, ')');
            //this.model.set('previouslyDisplayedTask',value);

            //Set the selectDown and selectUp funtions to ne noop
            this.selectDown = function($event) {
                return true;
            };
            this.selectUp = function($event) {
                return true;
            };

            if (value) {
                //If the last step was a prime, we will need to save it for the task result
                var prime = {
                    'primeId': null,
                    'preliminaryTime': null,
                    'primeTime': null
                };
                if (value.previousStep && value.previousStep.type && value.previousStep.type == 'prime') {
                    prime = value.previousStep.options;
                }

                var taskHandle = this.taskHandle = this.taskContainer.children('[data-task-id=\'' + value.name + '\'][data-exercise-id=\'' + value.exerciseId + '\'].task');
                //log.debug('found [data-task-id=\'' + value.name + '\'][data-exercise-id=\''+ value.exerciseId +'\'].task',taskHandle);
                //log.debug("this.taskHandle.attr('data-timeout')", this.taskHandle.attr('data-timeout'));
                var timeout = parseInt(this.taskHandle.attr('data-timeout'), 10);
                if (timeout >= 0) {} else {
                    timeout = 4000;
                }
                var correctBucket = this.taskHandle.attr('data-correct-Bucket');
                var autoPlayFunction = null;

                if (_.isString(this.taskHandle.attr('data-top-bucket'))) {
                    this.taskHandle.attr("data-original-top-bucket", this.model.get('bucket-top'));
                    this.model.set('bucket-top', this.taskHandle.attr('data-top-bucket'));
                }
                if (_.isString(this.taskHandle.attr('data-bottom-bucket'))) {
                    this.taskHandle.attr("data-original-bottom-bucket", this.model.get('bucket-bottom'));
                    this.model.set('bucket-bottom', this.taskHandle.attr('data-bottom-bucket'));
                }

                if (app.randomPlay) {
                    clearTimeout(app.autoPlayHandle);
                    autoPlayFunction = $.proxy(function() {
                        //
                        this.taskHandle.event = {
                            timeStamp: (new Date()).getTime()
                        };
                        var rand = Math.random();

                        //log.debug("correctBucket", correctBucket);

                        if (0 <= rand && 0.7 > rand) {
                            if (correctBucket == 'top') {
                                this.sessionView.upCorrect(this.taskHandle);
                            } else if (correctBucket == 'bottom') {
                                this.sessionView.downCorrect(this.taskHandle);
                            } else if (correctBucket == 'none') {
                                this.sessionView.upSelected(this.taskHandle);
                            }
                        } else if (0.7 <= rand && 0.95 > rand) {
                            if (correctBucket == 'top') {
                                this.sessionView.downIncorrect(this.taskHandle);
                                _.delay(_.bind(this.sessionView.upCorrect, sessionView), 550, this.taskHandle);
                            } else if (correctBucket == 'bottom') {
                                this.sessionView.upCorrect(this.taskHandle);
                                _.delay(_.bind(this.sessionView.downCorrect, sessionView), 550, this.taskHandle);
                            } else if (correctBucket == 'none') {
                                this.sessionView.downSelected(this.taskHandle);
                            }
                        } else {
                            if (correctBucket == 'top') {
                                this.sessionView.downIncorrect(this.taskHandle);
                                _.delay(_.bind(this.sessionView.upCorrect, sessionView), 1000, this.taskHandle);
                            } else if (correctBucket == 'bottom') {
                                this.sessionView.upCorrect(this.taskHandle);
                                _.delay(_.bind(this.sessionView.downCorrect, sessionView), 1000, this.taskHandle);
                            } else if (correctBucket == 'none') {
                                this.sessionView.downSelected(this.taskHandle);
                            }
                        }
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle,
                        'app': app
                    });
                } else if (app.autoPlayList && correctBucket == 'top') {
                    clearTimeout(app.autoPlayHandle);

                    autoPlayFunction = $.proxy(function() {
                        this.taskHandle.event = {
                            timeStamp: (new Date()).getTime()
                        };
                        this.sessionView.upCorrect(this.taskHandle);
                        this.app.sounds.playCorrect();
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle,
                        'app': app
                    });

                    //Increment the autoplay list
                    app.autoPlayListIndex = app.autoPlayListIndex + 1;
                    if (app.autoPlayListIndex > app.autoPlayList.length - 1) {
                        app.autoPlayListIndex = 0;
                    }
                } else if (app.autoPlayList && correctBucket == 'bottom') {
                    clearTimeout(app.autoPlayHandle);
                    autoPlayFunction = $.proxy(function() {
                        this.taskHandle.event = {
                            timeStamp: (new Date()).getTime()
                        };
                        this.sessionView.downCorrect(this.taskHandle);
                        this.app.sounds.playCorrect();
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle,
                        'app': app
                    });

                    //Increment the autoplay list
                    app.autoPlayListIndex = app.autoPlayListIndex + 1;
                    if (app.autoPlayListIndex > app.autoPlayList.length - 1) {
                        app.autoPlayListIndex = 0;
                    }
                } else if (correctBucket == 'top') {

                    this.selectUp = $.proxy(function($event) {
                        app.sounds.playCorrect();
                        this.taskHandle.event = $event;
                        this.sessionView.upCorrect(this.taskHandle);
                        return true;
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle
                    });

                    this.selectDown = $.proxy(function($event) {
                        app.sounds.playIncorrect();
                        this.taskHandle.event = $event;
                        this.sessionView.downIncorrect(this.taskHandle);
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle
                    });

                } else if (correctBucket == 'bottom') {

                    this.selectDown = $.proxy(function($event) {
                        app.sounds.playCorrect();
                        this.taskHandle.event = $event;
                        this.sessionView.downCorrect(this.taskHandle);
                        return true;
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle
                    });

                    this.selectUp = $.proxy(function($event) {
                        app.sounds.playIncorrect();
                        this.taskHandle.event = $event;
                        this.sessionView.upIncorrect(this.taskHandle);
                        return true;
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle
                    });
                } else if (correctBucket == 'none') {

                    this.selectDown = $.proxy(function($event) {
                        app.sounds.playCorrect();
                        this.taskHandle.event = $event;
                        this.sessionView.downSelected(this.taskHandle);
                        return true;
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle
                    });

                    this.selectUp = $.proxy(function($event) {
                        app.sounds.playCorrect();
                        this.taskHandle.event = $event;
                        this.sessionView.upSelected(this.taskHandle);
                        return true;
                    }, {
                        'sessionView': this,
                        'taskHandle': taskHandle
                    });
                }

                this.taskHandle.css({
                    'top': (this.viewHeight / 2) - (this.taskHandle.outerHeight() / 2)
                });
                this.taskHandle.removeClass('hidden');

                /*
          this.taskHandle.data('taskMeta', {
            'prime': prime,
            'exerciseId': value.exerciseId,
            'taskId': value.name,
            'displayStart': (new Date()).getTime()
          });

          this.taskHandle.attr({
            'data-prime': prime,
            'data-exerciseId': value.exerciseId,
            'data-taskId': value.name,
            'data-displayStart': (new Date()).getTime()
          });
        */
                this.taskHandle.taskMeta = {
                    'prime': prime,
                    'exerciseId': value.exerciseId,
                    'taskId': value.name,
                    'displayStart': (new Date()).getTime()
                };


                //We put this in a setTimeout to prevent the screen redraw from be included in the timing.
                setTimeout($.proxy(function() {
                    //ovewrite displayStart
                    if (this.taskHandle.data('taskMeta')) {
                        _.extend(this.taskHandle.data('taskMeta'), {
                            'displayStart': (new Date()).getTime()
                        });
                    }
                    if (this.autoPlayFunction && this.app.autoPlayList) {
                        this.app.autoPlayHandle = setTimeout(this.autoPlayFunction, this.app.autoPlayList[app.autoPlayListIndex]);
                    } else if (this.autoPlayFunction) {
                        this.app.autoPlayHandle = setTimeout(this.autoPlayFunction, (Math.random() * 200) + 200);
                    }
                }, {
                    'taskHandle': this.taskHandle,
                    'autoPlayFunction': autoPlayFunction,
                    'app': app
                }), 0);

                if (timeout > 0) {
                    this.taskTimeoutHandle = setTimeout($.proxy(function() {
                        //log.debug('Task Timed Out!', this.sessionView.taskTimeoutHandle);
                        delete(this.sessionView.taskTimeoutHandle);
                        this.sessionView.saveResult(this.sessionView.taskHandle, 'timeout');
                        this.sessionView.taskHandle.addClass('animated shakeFadeOut');
                        setTimeout($.proxy(function() {
                            this.taskHandle.addClass('hidden').removeClass('animated shakeFadeOut');
                            this.app.trigger('stepForward');
                        }, {
                            'taskHandle': this.sessionView.taskHandle,
                            'app': this.app
                        }), 500);
                        this.sessionView.endTaskCleanup();
                    }, {
                        'sessionModel': this.model,
                        'sessionView': this,
                        'taskName': value.name,
                        'app': app
                    }), timeout);
                } else {
                    this.fiveSecondArrows = {};
                    this.fiveSecondArrows.trigger = $.proxy(function() {
                        this.triggerArrowAnimation();
                        this.fiveSecondArrows.handle = setTimeout(this.fiveSecondArrows.trigger, 5000);
                    }, this);
                    this.fiveSecondArrows.handle = setTimeout(this.fiveSecondArrows.trigger, 5000);
                }
                //log.debug('Created setTimeout() id:' + this.taskTimeoutHandle + ' unless canceled, it will trigger in ' + timeout + 'ms.');

                if (this.model.get('taskArrowsHintsRemaining') > 0) {
                    this.triggerArrowAnimation();
                    this.model.set('taskArrowsHintsRemaining', this.model.get('taskArrowsHintsRemaining') - 1);
                }
            } else {
                //this.deactivateHandleSessionInput();
                this.selectDown = function($event) {
                    return true;
                };
                this.selectUp = function($event) {
                    return true;
                };
                this.taskContainer.children('.task').addClass('hidden');

                this.endTaskCleanup();
            }
        },
        endTaskCleanup: function(event) {
            if (this.taskTimeoutHandle) {
                //log.debug('Canceling task timeout:', this.taskTimeoutHandle);
                clearTimeout(this.taskTimeoutHandle);
            }
            if (this.taskHandle) {
                this.taskHandle.data('taskMeta', null);

                if (_.isString(this.taskHandle.attr("data-original-top-bucket"))) {
                    this.model.set('bucket-top', this.taskHandle.attr('data-original-top-bucket'));
                }

                if (_.isString(this.taskHandle.attr("data-original-bottom-bucket"))) {
                    this.model.set('bucket-bottom', this.taskHandle.attr('data-original-bottom-bucket'));
                }
            }



            if (this.fiveSecondArrows && this.fiveSecondArrows.handle) {
                clearTimeout(this.fiveSecondArrows.handle);
                delete this.fiveSecondArrows;
            }
            this.taskHandle = null;
            this.selectDown = function($event) {
                return true;
            };
            this.selectUp = function($event) {
                return true;
            };
            this.taskTimeout = function() {
                return false;
            };
            this.taskTimeoutHandle = null;
        },
        presentPrimeToUser: function(model, value, options) {
            if (value) {


                //Create a closure to show the prime later if there is a delay.
                var presentPrimeToUser = _.bind(
                    function(app, value) {
                        app.primeView.displayPrime(value.name, function() {
                            app.trigger('stepForward');
                        });
                    }, this, app, value);

                if (value.preliminarytime) {
                    setTimeout(presentPrimeToUser, value.preliminarytime);
                } else {
                    presentPrimeToUser();
                }
            } else {
                app.primeView.hidePrime();
            }
        },
        addImageTask: function(id, url, correctBucket, timeout, exerciseId, targetType, topBucket, bottomBucket) {
            //log.debug("addImageTask", arguments);
            domReady($.proxy(function(document) {
                img = null;
                if (app && app.sessionMedia) {
                    var imageModel = app.sessionMedia.get(this.imageUrl);
                    if (imageModel) {
                        img = imageModel.get('image').cloneNode();
                        //log.debug("img",img);
                    }
                }

                if (!img) {
                    img = new Image();
                    img.src = this.imageUrl + '?cb=' + parseInt(Math.random() * 99999999, 10);
                }

                var taskContainer = this.$el.find('.task-container');

                var taskEl = $(document.createElement('div'))
                    .addClass('task image hidden not-loaded')
                    .attr({
                        'data-exercise-id': this.exerciseId,
                        'data-task-id': this.taskId,
                        'data-correct-bucket': this.correctBucket,
                        'data-timeout': this.timeout,
                        'data-target-type': this.targetType,
                        'data-top-bucket': this.topBucket,
                        'data-bottom-bucket': this.bottomBucket
                    });

                var addImageToTaskContaner = $.proxy(function() {

                    this.taskEl.append($(this.img))
                        .removeClass('not-loaded')
                        .addClass('loaded');

                    this.taskEl.find('img')
                        .attr({
                            'data-src-width': img.width,
                            'data-src-height': img.height
                        });

                }, {
                    'taskEl': taskEl,
                    'img': img
                });



                //IE wont load untill image is in the dom.
                document.getElementById('img-loading-area').appendChild(img);

                if ((typeof img.naturalWidth != 'undefined' && img.naturalWidth > 0) || img.complete) {
                    addImageToTaskContaner();
                } else {
                    $(img).on('load', addImageToTaskContaner);
                }

                taskContainer.append(taskEl);
            }, {
                '$': $,
                '$el': this.$el,
                'taskId': id,
                'imageUrl': url,
                'correctBucket': correctBucket,
                'timeout': timeout,
                'exerciseId': exerciseId,
                'targetType': targetType,
                'topBucket': topBucket,
                'bottomBucket': bottomBucket
            }));
        },
        addTextTask: function(taskId, text, correctBucket, timeout, exerciseId, targetType, topBucket, bottomBucket) {
            //log.debug(taskId, text, correctBucket, timeout, exerciseId, topBucket, bottomBucket);
            var taskContainer = this.$el.find('.task-container');
            var taskEl = $(document.createElement('div'))
                .addClass('task text hidden')
                .attr({
                    'data-exercise-id': exerciseId,
                    'data-task-id': taskId,
                    'data-correct-bucket': correctBucket,
                    'data-timeout': timeout,
                    'data-target-type': targetType,
                    'data-top-bucket': topBucket,
                    'data-bottom-bucket': bottomBucket
                });
            var taskSourceEl = $(document.createElement('div'))
                .addClass('source')
                .html(text);
            var vCenterOuter = $(document.createElement('div')).addClass('v-center-outer');
            var vCenterInner = $(document.createElement('div')).addClass('v-center-inner');
            taskEl.append(vCenterOuter.append(vCenterInner.append(taskSourceEl)));
            taskContainer.append(taskEl);
        },
        addImagePrime: function(id, url, preliminaryTime, primeTime) {},
        addTextPrime: function(id, text, preliminaryTime, primeTime) {},
        pauseHandler: function(model, value, options) {
            if (value) {
                this.pauseButtom.removeClass('hidden');
            } else {
                this.pauseButtom.addClass('hidden');
            }
        },
        displayPauseDialog: function(model, value, options) {
            if (value) {
                this.pauseButtom.removeClass('pause').addClass('play');
                this.pauseDialog.removeClass('transparent');
                this.pauseDialog.find('.dialog-content').removeClass('hidden');
                //log.debug();
                var task = app.sessionScriptModel.currentStep();
                if (task && task.options && task.options.stepUID) {
                    this.model.set('pauseOnEvent', task.options.stepUID);
                }
                this.model.set('pauseStartTime', ((new Date()).getTime()));
                app.trigger('pause');
            } else {
                this.pauseButtom.removeClass('play').addClass('pause');
                this.pauseDialog.addClass('transparent');
                this.pauseDialog.find('.dialog-content').addClass('hidden');
                var pauses = app.sessionResultModel.get('pauses');
                pauses.push({
                    'event': this.model.get('pauseOnEvent'),
                    'time': (new Date()).getTime() - this.model.get('pauseStartTime')
                });
                app.trigger('unpause');
                this.verticallyCenterElements();
            }
        },
        //Runs just beofor the endcreen is shown.
        configureSessionEndLayout: function(model, value, options) {
            if (value) { // <-- show end session
                this.gaugeContainer.addClass('sessionEnd');
                this.outerFrame.addClass('gradient-background');

                if (app.subconsciousAssociations === true) {

                    //console.log("app",app);
                    var result = app.sessionResultModel.subconsciousAssociations();

                    this.maxSaGaugeLabel.removeClass('hidden');
                    this.minSaGaugeLabel.removeClass('hidden');
                } else {
                    this.speedGaugeLabel.removeClass('hidden');
                    this.accuracyGaugeLabel.removeClass('hidden');
                }
                if (
                    $(location).attr('href').indexOf('ProjectId=July2ndABA') > 0 ||
                    $(location).attr('href').indexOf('ProjectId=BeerST45demo') > 0
                ) {
                    $('.symbol').css('visibility', 'hidden');
                }

                if (!_.isEmpty(app.endCTA)) {
                    this.sessionEndDialog.removeClass('hidden');

                    /*var endcallback = window.close;


                    if (!_.isEmpty(app.endCallbackScriptUrl)) {
                        $('head')
                            .append('<script id="callback-target-script" type="text//javascript" src="' + app.endCallbackScriptUrl + '""><script//>');
                    }

                    if (!_.isEmpty(app.endCallback) && _.isFunction(window[app.endCallback])) {
                        console.debug("found callback", app.endCallback);
                        endcallback = window[app.endCallback];
                    }

                  var button = $('<a href="#"><div="bottom-bar"><div class="button wide bottom">' + app.endCTA + '</div></div></a>');
                    button.on('click', function() {
                        //log.debug("button click",endcallback);
                        endcallback.call(window);
                    });*/
  if (!_.isEmpty(app.caller)) {
    var button = $('<div class="bottom-bar"><div id="closeWindowButton" class=" button wide bottom retry-session" onclick="if (window.opener == null) {parent.closeSynapse();} else {window.opener.closeSynapse();}">Close Window</div></div>');
    this.sessionEndDialog.append(button);
    } else {
    if (!_.isEmpty(app.endRedir)) {
 var button = $('<div class="bottom-bar"><a href="'+app.endRedir+'" target="_blank"><div class="button wide bottom">' + app.endCTA + '</div></a></div>');
} else {
 var button = $('<div class="bottom-bar"><div class="button wide bottom" onclick="window.close();">' + app.endCTA + '</div></div>');
}
                this.sessionEndDialog.append(button);}

                   //this.sessionEndDialog.find('.message').text(value);
                }

            } else { // <-- hide end session
                this.gaugeContainer.removeClass('sessionEnd');
                this.outerFrame.removeClass('gradient-background');
                this.speedGaugeLabel.addClass('hidden');
                this.accuracyGaugeLabel.addClass('hidden');
            }
        },
        setMaxSaLabel: function(model, value, options) {
            //        log.debug("setMaxSaLabel",value);
            if (value) {
                var stringValue = value.toString();
                //stringValue = stringValue.replace('(##)', (model.get('averageSpeed')).toFixed(2));
                this.maxSaGaugeLabel.find('.content').html(stringValue);
            } else {
                this.maxSaGaugeLabel.find('.content').html('');
            }
        },
        setMaxSaIcon: function(model, value, options) {
            //        log.debug("setMaxSaIcon",value);
            if (value) {
                var stringValue = value.toString();
                this.maxSaGaugeIcon.html(stringValue);
            } else {
                this.maxSaGaugeIcon.html('');
            }
        },
        setMinSaLabel: function(model, value, options) {
            //        log.debug("setMinSaLabel",value);
            if (value) {
                var stringValue = value.toString();
                //stringValue = stringValue.replace('(##)', (model.get('averageAccuracy')).toFixed(2));
                this.minSaGaugeLabel.find('.content').html(stringValue);
            } else {
                this.minSaGaugeLabel.find('.content').html('');
            }
        },
        setMinSaIcon: function(model, value, options) {
            //        log.debug("setMinSaIcon",value);
            if (value) {
                var stringValue = value.toString();
                this.minSaGaugeIcon.html(stringValue);
            } else {
                this.minSaGaugeIcon.html('');
            }
        },
        setSpeedLabel: function(model, value, options) {
            if (value) {
                var stringValue = value.toString();
                stringValue = stringValue.replace('(##)', (model.get('averageSpeed')).toFixed(2));
                this.speedGaugeLabel.find('.content').text(stringValue);
            } else {
                this.speedGaugeLabel.find('.content').text('');
            }
        },
        setAccuracyLabel: function(model, value, options) {
            if (value) {
                var stringValue = value.toString();
                stringValue = stringValue.replace('(##)', (model.get('averageAccuracy')).toFixed(2));
                this.accuracyGaugeLabel.find('.content').text(stringValue);
            } else {
                this.accuracyGaugeLabel.find('.content').text('');
            }
        },
        setSessionEndMessage: function(model, value, options) {
            //log.debug('setSessionEndMessage', value);
            if (value && value.length > 0) {
                this.sessionEndDialog.removeClass('hidden');
                this.sessionEndDialog.find('.message').text(value);
            } else {
                this.sessionEndDialog.addClass('hidden');
                this.sessionEndDialog.find('.message').text('');
            }
        },
        updateScreenResolution: function() {
            var measureDiv = $(document.createElement('div')).css({
                width: '1cm',
                height: '1cm',
                position: 'absolute',
                top: 0,
                left: 0
            });
            this.$el.append(measureDiv);
            this.resolution = {
                'horizontal': {
                    'px/cm': measureDiv.width()
                },
                'vertical': {
                    'px/cm': measureDiv.height()
                }
            };
            //log.debug('measureDiv', measureDiv.width());
            measureDiv.remove();
            if (this.touchView) {
                this.touchView.resolution = this.resolution;
                if (this.touchView.$canvas) {
                    this.touchView.$canvas.attr({
                        'width': this.touchView.$canvas.width(),
                        'height': this.touchView.$canvas.height()
                    });
                }
            }
        },
        setIconsVisible: function(model, value) {
            // log.debug('setIconsVisible', arguments);
            if (value === false) {
                this.speedGauge.find('.symbol').hide();
                this.accuracyGauge.find('.symbol').hide();
            } else {
                this.speedGauge.find('.symbol').show();
                this.accuracyGauge.find('.symbol').show();
            }
        },
        triggerRetrySession: $.proxy(
            function() {
                this.app.trigger('restart');
            }, {
                'app': app,
                'model': this.model
            }
        )
    });
    return SessionView;
});
